import { Config } from "../../core/config/config";
import React from "react";

const translations_reports = {
    get noRights() {
        return __internal_translations["WebSMS.UserSettings.GroupRights.0"];
    },
    get noEntries() {
        return __internal_translations["Standard.Msg.KeineErgebnisse"];
    },
    get openInNewTab() {
        return __internal_translations["WebSMS.Common.OpenInNewTab"];
    },
    get technicalApproval() {
        return __internal_translations["Field.Beleg.freigabe"];
    },
    get commercialApproval() {
        return __internal_translations["Field.Beleg.abrmon"];
    }
};

class NoEntries extends React.Component<any, any>{
    render() {
        return <div className="material-card-rep-container-user">
            <div style={{ textAlign: "center", color: "#000000", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#FFFFFF", opacity: "0.5"}}>
                <i className="fal fa-empty-set" style={{fontSize: "5em", marginBottom: "10px"}}></i>
                <div style={{fontFamily: "Roboto"}}>{translations_reports.noEntries}</div>
            </div>
        </div>
    }
}

class NoEntriesVorschau extends React.Component<any, any>{
    render() {
        return <div className="user_report_vorschau">
            <div style={{ textAlign: "center", color: "#000000", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", backgroundColor: "#FFFFFF", opacity: "0.5"}}>
                <i className="fal fa-empty-set" style={{fontSize: "5em", marginBottom: "10px"}}></i>
                <div style={{fontFamily: "Roboto"}}>{translations_reports.noEntries}</div>
            </div>
        </div>
    }
}

interface rowData{
    RESOURCE:string;
    DAYSSINCEIMPORT:number;
    IMPORTDATE:string;
    ENTRY_LINK:string;
    REPORTNO:string;
    ENTRY_PHONE:string;
    ENTRY_TECH_FREIGABE:boolean;
    ENTRY_SHOW_TECH_FREIGABE:boolean;
    ENTRY_RECHT_TECH_FREIGABE:boolean;
    ENTRY_COMM_FREIGABE:boolean;
    ENTRY_SHOW_COMM_FREIGABE:boolean;
    ENTRY_RECHT_COMM_FREIGABE: boolean;
    ENTRY_KENNUNG:string;
    PROJECTNO:string;
    ENTRY_KENNWORT:string;
    VON_BIS: string;
    KW_TEXT: string;
    CUSTOMERNAME:string;
    ENTRY_DOC_ISGUID:string;
    HAS_DOC: number;
    onclick:any;
    isSelected?:boolean;
    API_ID_TECH_FREIGABE:string;
    API_ID_COMM_FREIGABE: string;
    onGiveTechnicalApproval:(belegNr:string, apiID: string)=>void
    onGiveCommercialApproval:(belegNr:string, apiID: string)=>void
}


class Row extends React.Component<rowData,any>{
    openLink = () => {
        if (this.props.ENTRY_LINK && (this.props.ENTRY_LINK != "")) window.open(Config.baseUrl + this.props.ENTRY_LINK, "_blank");
    }

    technischeFreigabeErteilen =()=>{
        this.props.onGiveTechnicalApproval(this.props.REPORTNO, this.props.API_ID_TECH_FREIGABE);        
    }

    kaufmaennischeFreigabeErteilen =()=>{
        this.props.onGiveCommercialApproval(this.props.REPORTNO, this.props.API_ID_COMM_FREIGABE);
    }

    stopPropagation =(e)=>{
        e.stopPropagation();
    }


    render(){
     
        return <div  style={{borderLeft:this.props.isSelected?"5px solid #303F9F":"5px solid #ffffff", backgroundColor: "#ffffff", borderBottom: "1px solid #cccccc"}}  className="material-card-rep-user material-card-rep-user-clickable" onClick={()=>this.props.onclick(this.props.ENTRY_DOC_ISGUID)}>

            <div className="grid-item1" style={{gridArea: "ButtonOpen"}} onClick={this.openLink}>
                <span className="external-Reports-user buttonIcon" style={{height: "30px", width: "30px"}}>
                    <i style={{fontSize: "20px", fontWeight: 400}} className="far fa-external-link" title={translations_reports.openInNewTab}></i>
                </span>
            </div>
        
            <div className= "grid-item2" style={{gridArea: "Resource", fontFamily: "Roboto"}}>
                <span style={{fontWeight: "bold", fontSize: "15px", color: "black"}}>
                    {this.props.RESOURCE}
                </span>                    
            </div>

            <div className="grid-item7" style={{gridArea: "IconImport", marginLeft: "auto", marginRight: "auto"}}>
                {
                    (this.props.DAYSSINCEIMPORT != -1) ?
                    (
                        (this.props.DAYSSINCEIMPORT <= 7) ?
                        (
                            <span style={{fontStyle: "italic", fontWeight: "bold", fontSize: "15px", color: "#4a4a4a", fontFamily: "Roboto"}}>
                                <i className="fa fa-exclamation-triangle" style={{color: "green", fontSize: "25px", fontWeight: 400}}></i>
                            </span>
                        )
                        :
                        (
                            (this.props.DAYSSINCEIMPORT <= 14) ?
                            (
                                <span style={{fontStyle: "italic", fontWeight: "bold", fontSize: "15px", color: "#4a4a4a", fontFamily: "Roboto"}}>
                                    <i className="fa fa-exclamation-triangle" style={{color: "#ffB000", fontSize: "25px", fontWeight: 400}}></i>
                                </span>
                            )
                            :
                            (
                                <span style={{fontStyle: "italic", fontWeight: "bold", fontSize: "15px", color: "#4a4a4a", fontFamily: "Roboto"}}>
                                    <i className="fa fa-exclamation-triangle" style={{color: "red", fontSize: "25px", fontWeight: 400}}></i>
                                </span>
                                
                            )
                        )
                    )
                    : null
                }
            </div>

            <div className="grid-item10" style={{gridArea: "TageImport", marginLeft: "auto", marginRight: "auto"}}>
                {
                    (this.props.IMPORTDATE != "") ?
                    (
                        <span style={{fontWeight: "bold", fontSize: "15px", color: "#4a4a4a", fontFamily: "Roboto"}}>
                            {kendo.toString(kendo.parseDate(this.props.IMPORTDATE), 'd')}
                        </span>
                    )
                    :
                    null
                }
            </div>

            <div className="grid-item8" style={{gridArea: "BelegNr"}}>
                <span style={{color: "#4a4a4a", fontWeight: "bold", fontFamily: "Roboto"}}>
                    {this.props.REPORTNO}
                </span>
            </div>
            
            <div className="grid-item3" style={{gridArea: "AdressnameKW"}}>
                <span style={{fontSize: "15px", color: "black", fontFamily: "Roboto"}}>
                    {
                        (["WB", "RB"].includes(this.props.PROJECTNO)) ? 
                        (
                           this.props.KW_TEXT
                        )
                        : (this.props.CUSTOMERNAME)                        
                    }
                </span>
            </div>

            <div className="grid-item9" style={{gridArea: "ProjektVonBis"}}>
                <span style={{fontFamily: "Roboto", color: "black", fontWeight: "bold"}}>
                  {
                    (this.props.PROJECTNO != "") ?
                    (
                        (["WB", "RB"].includes(this.props.PROJECTNO)) ? 
                        (
                            this.props.VON_BIS
                        )
                        : (this.props.PROJECTNO + " - " + this.props.ENTRY_KENNWORT)
                    )
                    : null
                  }
                </span>
            </div>

            <div className="grid-item11" style={{gridArea: "ProjektVonBisMobile"}}>
                <span style={{fontFamily: "Roboto", color: "black", fontWeight: "bold"}}>
                  {
                    (this.props.PROJECTNO != "") ?
                    (
                        (this.props.PROJECTNO == "WB")?
                            this.props.KW_TEXT
                        :
                        (
                            (this.props.PROJECTNO == "RB") ? 
                            (
                                this.props.VON_BIS
                            )
                            : (this.props.ENTRY_KENNWORT)
                        )
                    )
                    : null
                  }
                </span>
            </div>
        
            <div className= "grid-item4" style={{gridArea: "Kennung"}}>
                <span style={{fontWeight: "bold", fontSize: "15px", color: "black", textAlign: "center", fontFamily: "Roboto"}}>
                  {this.props.ENTRY_KENNUNG}
                </span>
            </div>

            <div className="grid-item5" style={{gridArea: "TechnischeFreigabe"}}>
                {
                    (this.props.ENTRY_SHOW_TECH_FREIGABE) ? 
                    (   //Freigabe soll angezeigt werden, bzw. gibt es bei diesem Belegtyp überhaupt
                        (this.props.ENTRY_TECH_FREIGABE) ?
                        (   //Freigabe vorhanden
                            <span className="icon-t_freigabe-erteilt" style={{display: "flex", alignItems: "center", height: "35px"}}>
                                <i className ="fa-thin fa-thumbs-up" style={{fontSize: "25px", fontWeight: 400, color: "#4CAF50"}} title={translations_reports.technicalApproval}></i>
                            </span>
                        )
                        : 
                        (
                            (this.props.ENTRY_RECHT_TECH_FREIGABE) ?
                            (   //Freigabe *nicht* vorhanden, hat Rechte die Freigabe zu setzen
                                <span className="icon-t_freigabe buttonIcon" style={{display: "flex", alignItems: "center", height: "35px"}} onClick={this.technischeFreigabeErteilen}>
                                    <i className ="fa-thin fa-thumbs-up" style={{fontSize: "25px", fontWeight: 400}} title={translations_reports.technicalApproval}></i>
                                </span>
                            )
                            :
                            (   //Freigabe *nicht* vorhanden, hat *keine* Rechte die Freigabe zu setzen
                                <span className="icon-t_freigabe" style={{display: "flex", alignItems: "center", justifyContent: "center", height: "35px"}}>
                                    <i className ="fa-thin fa-thumbs-up" style={{fontSize: "25px", fontWeight: 400, color: "rgb(199, 78, 78, 0.5)"}} title={translations_reports.noRights}></i>
                                </span>
                            )
                        )
                    ) 
                    : null
                }
            </div>

            
            <div className="grid-item6" style={{gridArea: "KaufmFreigabe"}}>
                {
                    (this.props.ENTRY_SHOW_COMM_FREIGABE) ?
                    (   //Freigabe soll angezeigt werden, bzw. gibt es bei diesem Belegtyp überhaupt
                        (this.props.ENTRY_COMM_FREIGABE) ?
                        (   //Freigabe vorhanden
                            <span className="icon-t_freigabe-erteilt">
                                <i className ="fa-thin fa-file-signature" style={{fontSize: "25px", fontWeight: 400, color: "#4CAF50"}} title={translations_reports.commercialApproval}></i>
                            </span>
                        )
                        : 
                        (
                            (this.props.ENTRY_RECHT_COMM_FREIGABE) ?
                            (   //Freigabe *nicht* vorhanden, hat Rechte die Freigabe zu setzen
                                <span className="icon-t_freigabe buttonIcon" onClick={this.kaufmaennischeFreigabeErteilen}>
                                    <i className ="fa-thin fa-file-signature" style={{fontSize: "25px", fontWeight: 400}} title={translations_reports.commercialApproval}></i>
                                </span>
                            )
                            :
                            (   //Freigabe *nicht* vorhanden, hat *keine* Rechte die Freigabe zu setzen
                                <span className="icon-t_freigabe">
                                    <i className ="fa-thin fa-file-signature" style={{fontSize: "25px", fontWeight: 400, color: "rgb(199, 78, 78, 0.5)"}} title={translations_reports.noRights}></i>
                                </span>
                            )
                        )
                    )
                    : null
                }
            </div>


            <div className="grid-item12" style={{gridArea: "FreigabenMobile"}}>
                {
                    (this.props.ENTRY_SHOW_TECH_FREIGABE) ? 
                    (   //Freigabe soll angezeigt werden, bzw. gibt es bei diesem Belegtyp überhaupt
                        (this.props.ENTRY_TECH_FREIGABE) ?
                        (   //Freigabe vorhanden
                            <span className="icon-t_freigabe-erteilt" style={{display: "flex", alignItems: "center"}}>
                                <i className ="fa-thin fa-thumbs-up" style={{fontSize: "25px", fontWeight: 400, color: "#4CAF50"}} title={translations_reports.technicalApproval}></i>
                            </span>
                        )
                        : 
                        (
                            (this.props.ENTRY_RECHT_TECH_FREIGABE) ?
                            (   //Freigabe *nicht* vorhanden, hat Rechte die Freigabe zu setzen
                                <span className="icon-t_freigabe buttonIcon" style={{display: "flex", alignItems: "center"}} onClick={this.technischeFreigabeErteilen}>
                                    <i className ="fa-thin fa-thumbs-up" style={{fontSize: "25px", fontWeight: 400}} title={translations_reports.technicalApproval}></i>
                                </span>
                            )
                            :
                            (   //Freigabe *nicht* vorhanden, hat *keine* Rechte die Freigabe zu setzen
                                <span className="icon-t_freigabe" style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                                    <i className ="fa-thin fa-thumbs-up" style={{fontSize: "25px", fontWeight: 400, color: "rgb(199, 78, 78, 0.5)"}} title={translations_reports.noRights}></i>
                                </span>
                            )
                        )
                    ) 
                    : null
                }
                {
                    (this.props.ENTRY_SHOW_COMM_FREIGABE) ?
                    (   //Freigabe soll angezeigt werden, bzw. gibt es bei diesem Belegtyp überhaupt
                        (this.props.ENTRY_COMM_FREIGABE) ?
                        (   //Freigabe vorhanden
                            <span className="icon-t_freigabe-erteilt">
                                <i className ="fa-thin fa-file-signature" style={{fontSize: "25px", fontWeight: 400, color: "#4CAF50"}} title={translations_reports.commercialApproval}></i>
                            </span>
                        )
                        : 
                        (
                            (this.props.ENTRY_RECHT_COMM_FREIGABE) ?
                            (   //Freigabe *nicht* vorhanden, hat Rechte die Freigabe zu setzen
                                <span className="icon-t_freigabe buttonIcon" onClick={this.kaufmaennischeFreigabeErteilen}>
                                    <i className ="fa-thin fa-file-signature" style={{fontSize: "25px", fontWeight: 400}} title={translations_reports.commercialApproval}></i>
                                </span>
                            )
                            :
                            (   //Freigabe *nicht* vorhanden, hat *keine* Rechte die Freigabe zu setzen
                                <span className="icon-t_freigabe">
                                    <i className ="fa-thin fa-file-signature" style={{fontSize: "25px", fontWeight: 400, color: "rgb(199, 78, 78, 0.5)"}} title={translations_reports.noRights}></i>
                                </span>
                            )
                        )
                    )
                    : null
                }
            </div>
            
        </div>

    }
}





export class CompMain_Reports extends React.Component<any, {activeIndex:number,docGuid?:string,hasDocs:boolean, projNr:string, belegNr: number}>{
    constructor(props,state){
        super(props,state);
        this.state={activeIndex:0,hasDocs:false, projNr:"", belegNr: null};
        document.addEventListener("visibilitychange",()=>{this.props.api.reloadStatistic()})
    }

    refreshStatistic=()=>{
        window["DelphiInterop"].statisticWidgets[this.props.context.STATISTIC_WIDGET_ID].api.reload();
    }

    handlePageChanged = (pageIndex) => {
        this.setState({activeIndex:pageIndex});
    }

    handleGiveTechnicalApproval = (belegnr:string, apiID: string)=>{ //7ea6e352-f00d-482f-825c-0abfcee8ccff
        window.fetch(Config.baseUrl + `Statistic/api/dynamicapi/${apiID}/GetData?Belegnr=${belegnr}`);
        this.props.api.reloadStatistic();
    }

    handleGiveCommercialApproval = (belegnr:string, apiID: string)=>{ //11d63e15-f37f-4e1c-8ac4-3d168ce20d2f
        window.fetch(Config.baseUrl + `Statistic/api/dynamicapi/${apiID}/GetData?Belegnr=${belegnr}`);
        this.props.api.reloadStatistic();
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<{ activeIndex: number; docGuid?: string; }>, snapshot?: any): void {
        if(this.props.data!=prevProps.data){
            this.setState({activeIndex:0})
        }
    }

    
    render() {
        const cssProps:React.CSSProperties = {display:"inline-flex"};
        const filteredData = this.props.data?.filter((e,i)=>i>=this.state.activeIndex * 10 && i < (this.state.activeIndex+1)*10);
        return  <>
            <style>{css}</style>
            <div style={{height: "100%", display: "flex"}}>
                <div style={{display: "flex", flexDirection: "column"}}>
                    <div className="material-card-rep-user-list" style={{flex: "1"}}>
                        {this.props.data && this.props.data.length==0 ? <NoEntries></NoEntries>:null} 
                        <div className="material-card-rep-container-user">
                            {filteredData.map((r)=><Row
                                isSelected ={this.state.docGuid ? this.state.docGuid == r.ENTRY_DOC_ISGUID : false}
                                RESOURCE={r.RESOURCE ? r.RESOURCE : ""}
                                DAYSSINCEIMPORT={r.DAYSSINCEIMPORT ? r.DAYSSINCEIMPORT : -1}
                                IMPORTDATE={r.IMPORTDATE ? r.IMPORTDATE : ""}
                                ENTRY_LINK={r.ENTRY_LINK ? r.ENTRY_LINK : ""}
                                REPORTNO={r.REPORTNO ? r.REPORTNO : ""}
                                ENTRY_PHONE={r.ENTRY_PHONE ? r.ENTRY_PHONE : ""}
                                ENTRY_TECH_FREIGABE={r.ENTRY_TECH_FREIGABE > 0 ? true : false}
                                ENTRY_SHOW_TECH_FREIGABE={r.ENTRY_SHOW_TECH_FREIGABE > 0 ? true : false}
                                ENTRY_COMM_FREIGABE={r.ENTRY_COMM_FREIGABE > 0 ? true : false}
                                ENTRY_SHOW_COMM_FREIGABE={r.ENTRY_SHOW_COMM_FREIGABE > 0 ? true : false}
                                ENTRY_RECHT_COMM_FREIGABE={r.ENTRY_RECHT_COMM_FREIGABE == 1 ? true : false}
                                ENTRY_RECHT_TECH_FREIGABE={r.ENTRY_RECHT_TECH_FREIGABE == 1 ? true : false}
                                ENTRY_KENNUNG={r.ENTRY_KENNUNG? r.ENTRY_KENNUNG : "-"}
                                PROJECTNO={r.PROJECTNO ? r.PROJECTNO : ""}
                                ENTRY_KENNWORT={r.ENTRY_KENNWORT ? r.ENTRY_KENNWORT : ""}                        
                                VON_BIS={r.VON_BIS ? r.VON_BIS : ""}
                                KW_TEXT={r.KW_TEXT ? r.KW_TEXT : ""}                        
                                CUSTOMERNAME={r.CUSTOMERNAME ? r.CUSTOMERNAME : ""}
                                ENTRY_DOC_ISGUID={r.ENTRY_DOC_ISGUID ? r.ENTRY_DOC_ISGUID : ""}
                                HAS_DOC={r.HAS_DOC ? r.HAS_DOC : 0}
                                onclick={(docGuid)=>{this.setState({docGuid:docGuid, hasDocs:r.HAS_DOC>0, projNr: r.PROJECTNO, belegNr: r.REPORTNO})}}
                                API_ID_TECH_FREIGABE={r.API_ID_TECH_FREIGABE ? r.API_ID_TECH_FREIGABE : ""}
                                API_ID_COMM_FREIGABE={r.API_ID_COMM_FREIGABE ? r.API_ID_COMM_FREIGABE : ""}
                                onGiveTechnicalApproval={this.handleGiveTechnicalApproval}
                                onGiveCommercialApproval={this.handleGiveCommercialApproval}
                            ></Row>)}
                        </div>
                    </div>
                    <Pager data={this.props.data} activeIndex={this.state.activeIndex} onPageChanged={this.handlePageChanged}/>
                </div>
                {
                    (this.state.hasDocs && this.state.projNr != 'WB' && this.state.projNr != 'RB') 
                    ? <iframe className="user_report_vorschau_iframe" src={Config.baseUrl + "/pdfviewer/web/viewer.html?file=" + Config.baseUrl + "/Document/Download/"+this.state.docGuid}></iframe>
                    : (this.state.projNr == "RB")
                    ? <iframe className="user_report_vorschau_iframe" src={Config.baseUrl + `/TravelReport/Edit?id=${this.state.belegNr}&isReadonly=true&kioskmode=true`}></iframe>
                    : (this.state.projNr == "WB")
                    ? <iframe className="user_report_vorschau_iframe" src={Config.baseUrl + `/WeeklyReport/Edit?id=${this.state.belegNr}&isReadonly=true&kioskmode=true`}></iframe>
                    : <NoEntriesVorschau></NoEntriesVorschau>
                }
            </div>
        </>
    }

}
class Pager extends React.Component<{activeIndex:number,onPageChanged, data:any[]},any>{
    private pagerDiv:HTMLDivElement;
    private kendoPager;

    handlePageClick = (pageIndex:number) => {
        this.props.onPageChanged(pageIndex);
    }

    componentDidMount(): void {
        const dataSource = new kendo.data.DataSource({
            data: this.props.data,
            pageSize: 10,
          });
             
          
          const that = this;
          this.kendoPager =  $(this.pagerDiv).kendoPager({
            dataSource: dataSource,            
            change: function() {
              that.props.onPageChanged(this.page()-1);
            }
          }).data("kendoPager");
          const p = this.kendoPager.setDataSource(dataSource);

    }
    componentWillUnmount(): void {
        this.kendoPager.destroy();
    }

    componentDidUpdate(prevProps: Readonly<{ activeIndex: number; onPageChanged: any; data: any[]; }>, prevState: Readonly<any>, snapshot?: any): void {
        if(this.props.data !== prevProps.data){  
        const dataSource = new kendo.data.DataSource({
            data: this.props.data,
            pageSize: 10
          });
        const p = this.kendoPager.setDataSource(dataSource);
        }
    }

    renderPager=()=>{
        const aa:any[] = [];
        for(let i=0;i<=(this.props.data.length / 10);i++){
            aa.push(<a onClick={()=>this.handlePageClick(i)} className={i==this.props.activeIndex?"active":""} style = {{color: "black"}}>{i+1}</a>)
        }
        return aa;
    }

    render(){
        return <div style={{position: "sticky", bottom: "0px"}} ref={(e)=>this.pagerDiv = e}></div>
    }
}

const css = `
 
    .pagination {
        display: grid;
        grid-template-columns: auto 1fr;
        background-color: white;
        justify-content: flex-start;
        height: 40px;
    }

     .pagination > div {
        text-align: center;
        padding: 20px 0;
        font-size: 30px;
    }

    .pagination a {
        color: black;
        float: left;
        padding: 8px 16px;
        text-decoration: none;
        transition: background-color .3s;
    }

    .pagination a.active {
        background-color: #303F9F;
        color: #303F9F;
    }

    .pagination a:hover:not(.active) {background-color: #ddd; color: #303F9F}

    .grid-item1, .grid-item4, .grid-item5, .grid-item7, .grid-item6, .grid-item10 {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .grid-item2, .grid-item3, .grid-item8, .grid-item9 {
        display: flex;
        align-items: center;
    }

    .grid-item11, .grid-item12 {
        display: none;
    }

    .material-card-rep-user{
        border: none;
        display: grid;
        background-color: #f5f5f5;

        grid-template-areas: 
        'ButtonOpen IconImport Resource ProjektVonBis Kennung TechnischeFreigabe KaufmFreigabe'
        'ButtonOpen TageImport BelegNr AdressnameKW Kennung TechnischeFreigabe KaufmFreigabe' ;

        grid-template-columns: 60px 140px 170px 280px 170px 60px 60px;
        grid-template-rows: 34px 34px;
    }

    .user_report_vorschau {
        display: flex;
        flex: 1 1 0%;
        justify-content: center;
    }

    .user_report_vorschau_iframe {
        flex: 1 1 0%; 
        height: 100%;
        width: 100%;
        display: block;
    }

    @media only screen and (max-width: 480px) {

        .user_report_vorschau, .user_report_vorschau_iframe {
            display:none;
        }
       
        .material-card-rep-user{
            grid-template-areas: 
            'ButtonOpen Resource ProjektVonBisMobile'
            'IconImport BelegNr FreigabenMobile' ;

            grid-template-columns: 60px 140px auto;
            grid-template-rows: auto;
        }

        .grid-item1, .grid-item2, .grid-item7, .grid-item8{
            display:flex;
        }

        .grid-item11, .grid-item12{
            display: flex;
            align-items: center;
        }

        .grid-item3, .grid-item4, .grid-item5, .grid-item6, .grid-item9, .grid-item10 {
            display:none;
        }
    }

    .icon-t_freigabe {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 35px;
        width: 35px;
    }

    .icon-t_freigabe:hover {
        color: #303F9F;
        animation-name: buttonhover-fade;
        animation-duration: .3s;
    }

    @keyframes buttonhover-fade {
        from {
            color: black;
        }
 
        to {
            color: #303F9F;
        }
    }

    .icon-t_freigabe-erteilt {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 35px;
        width: 35px;
        border: 1px solid transparent;
        color: #4CAF50;
        transition: color 0.3s ease; 
    }

    .material-card-rep-user material-card-rep-user-clickable > div{
        text-align: center;
        padding: 20px 0; 
        font-size: 30px;
    }

    .material-card-rep-user-list{
        font-family: Open Sans;
        line-height: 1.4;
        height: 100%;
        overflow: auto;
    }


    .material-header-title{
        display: grid;
        grid-template-columns: auto auto auto 1fr;
        background-color: white;
        justify-content: flex-start;
        height: 55px;
    }

    .material-header-title > div {
        text-align: center;
        padding: 20px 0;
        font-size: 30px;
    }
    
    .material-card-rep-container-user{
        overflow: auto;
    }

   .external-Reports-user {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        width: 50px;
        border: 1px solid transparent;
        transition: border-color 0.3s ease; 
    }

    .buttonIcon {
        transition: all .3s ease-in-out;
    }

    .buttonIcon:hover {
        cursor: pointer;
        transform: scale(1.3);
        color: #303F9F; 
    }

    .material-card-rep-user material-card-rep-user-clickable{
        backgroundColor: "#ffffff",
        borderBottom: "1px solid #cccccc",
        transition: "background-color 0.3s ease",
    }

    .material-card-rep-user material-card-rep-user-clickable:hover{
        background-color: #e3e3e3;
    }

    .material-div-link {
        position:absolute;
        width:100%;
        height:100%;
        top:0;
        left: 0;
        z-index: 1;
    }
}
`